/**
 *  Searcher script file
**/

import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'app-searcher',
  mixins: [setDeviceWidthClass],
  components: {},
  props: {
    placeholder: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    search: {
      type: String,
      default: '',
      required: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputValue: this.search
    }
  },
  mounted () {
    if (this.autofocus && !this.search) {
      this.onFocus()
    }
  },
  computed: {
    active () {
      return !!this.inputValue.length
    }
  },
  methods: {
    onFocus () {
      this.$refs.input.focus()
      this.$emit('focus', this.name)
    },
    onEnterKey () {
      this.$emit('onEnterKey')
      const list = document.querySelector('#pois-list')
      list.focus()
    },
    onBlur (e) {
      e.target.blur()
      this.$emit('blur', this.name)
    },
    onInputChange () {
      this.$emit('onActive', this.active)

      if (!this.inputValue.length) {
        return this.onClear()
      }

      if (this.inputValue.length >= 2) {
        this.$emit('onInputChange', { value: this.inputValue, name: this.name })
        this.$parent.$emit('onInputChange', { value: this.inputValue, name: this.name })
      }
    },
    onClear (autofocus) {
      this.inputValue = ''
      if (autofocus) {
        this.onFocus()
      }
      this.$emit('onInputChange', { name: this.name })
      this.$emit('onActive', this.active)
      return this.$parent.$emit('onInputChange', { name: this.name })
    }
  },
  watch: {
    search (value) {
      this.inputValue = value
    }
  }
}
